import { render, staticRenderFns } from "./babianxing.vue?vue&type=template&id=0b0cdcaa&scoped=true&"
import script from "./babianxing.vue?vue&type=script&lang=js&"
export * from "./babianxing.vue?vue&type=script&lang=js&"
import style0 from "./babianxing.vue?vue&type=style&index=0&id=0b0cdcaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0cdcaa",
  null
  
)

export default component.exports